export default __webpack_public_path__ + "static/landing-collab-bottom-image-a-ef12a4a57b190e9a0c7c51a685108693.png";